import React from 'react';
import FileUploader from 'devextreme-react/file-uploader';
import './index.scss';
import { configureMdaeWidgetOptionUpdaters,DX_WIDGET_NAMES } from '../../mdae-framework';
import { IMdaeFileUploaderProps } from "./index";
import { useDispatch } from "react-redux";

const MdaeFileUploader: React.FC<IMdaeFileUploaderProps> = props => {
  const dispatch = useDispatch();
  return (
    <FileUploader
      uploadMode="useButtons"
      selectButtonText="Browse"
      className={"sys-mdae-file-uploader-content" + (props.showUploadButton ? " show-upload-button" : " hide-upload-button")}
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_FILE_UPLOADER,
          e.component,
          dispatch
        );
      }}
    />
  );
};

export default MdaeFileUploader;
